<script lang="ts">
  import type { PlayerInterface } from '@foundation-player/loader';

  export let player: PlayerInterface | undefined = undefined;

  const openAdLink = () => {
    player?.getAdvertisingAdapter()?.openClickThrough();
  };
</script>

<button type="button" on:click={openAdLink} class="ad-link">Zum Werbetreibenden</button>

<style module>
  .ad-link {
    /* Make button look like a link */
    border: none;
    padding: 0 8px;
    background: none;
    text-decoration: underline;
    border-radius: 0;
    cursor: pointer;

    position: absolute;

    top: 4px;
    top: clamp(0px, 1cqw - 4px, 4px);

    right: 4px;
    right: clamp(0px, 1cqw - 4px, 4px);

    background: transparent;
    background: var(--icon-background-color);

    color: #f0f0f0;
    color: var(--icon-color);

    line-height: 44px;
    line-height: clamp(28px, 6.875cqw, 44px);

    font-size: inherit;
    white-space: nowrap;
    text-shadow: 0 0 4px rgba(0, 0, 0, 0.75);
  }

  @media (prefers-reduced-motion: no-preference) {
    .ad-link {
      transition: 0.3s ease-in-out;
      transition-property: background-color, color;
    }
  }

  .ad-link:active,
  .ad-link:focus-visible {
    color: #ffffff;
    color: var(--icon-hover-color);

    background: #000000;
    background: var(--icon-hover-background-color);
  }

  @media (prefers-contrast: more) {
    .ad-link:hover {
      outline: var(--outline);
    }

    .ad-link:active {
      outline: var(--outline);
    }

    .ad-link {
      background: var(--controls-contrast-background);
      text-shadow: none;
    }
  }

  @media (prefers-contrast: more) and (prefers-reduced-transparency: reduce) {
    .ad-link {
      background: var(--controls-no-transparency-background);
    }
  }

  @media (hover: hover) {
    .ad-link:hover {
      color: #ffffff;
      color: var(--icon-hover-color);

      background: #000000;
      background: var(--icon-hover-background-color);
    }

    @media (prefers-contrast: more) {
      .ad-link:hover {
        outline: var(--outline);
      }
    }
  }
</style>
